import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class StaticinforpageApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'staticinforpage'
    }

    /**
     * 保存或更新帮助文档
     * @param param 
     * @returns 
     */
    public saveText(param){
      return this.send(param,"saveText",Methods.POST)
    }

    /**
     * 模块id查询帮助文档
     * @param moduleId 
     */
    public getStaticInforPage(moduleId){
      return this.send({moduleId:moduleId},"getStaticInforPage",Methods.GET)
    }
   

   
}